// //Perf
// import React, { useMemo, useState, useRef, useEffect } from "react";
// import styled from "styled-components";
// import { NavLink, useNavigate, useLocation } from "react-router-dom";
// import { useMediaQuery } from "react-responsive";
// import {
//   FaBars,
//   FaTimes,
//   FaUserCircle,
//   FaBullseye,
//   FaChartLine,
//   FaHandsHelping,
//   FaShieldAlt,
//   FaClipboardList,
//   FaFolderOpen,
//   FaCog,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import { useTheme } from "../App"; 

// /* ================= DATA ================= */
// const navItems = [
//   // { to: "/profile", label: "Profile", icon: <FaUserCircle /> },
//   { to: "/dashboard", label: "Dashboard", icon: <FaBullseye /> },
//   { to: "/live", label: "Live", icon: <FaChartLine /> },
//   {
//     to: "/training",
//     label: (
//       <>
//         Messages
//       </>
//     ),
//     icon: <FaHandsHelping />,
//   },
//   { to: "/message", label: "Discipleship", icon: <FaShieldAlt /> },
//   {
//     to: "/discipleship",
//     label: "My Custom Trainings",
//     icon: <FaClipboardList />,
//   },
//   // { to: "/records", label: "Records", icon: <FaFolderOpen /> },
//   { to: "/settings", label: "Settings", icon: <FaCog /> },
// ];

// /* ================= STYLED COMPONENTS ================= */
// const Sidebar = styled.aside`
//   width: ${({ collapsed }) => (collapsed ? "88px" : "280px")};
//   height: 100vh;
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(30, 41, 59, 0.96)' : 'rgba(255, 255, 255, 0.96)'};
//   backdrop-filter: blur(12px);
//   border-right: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.9)'};
//   position: fixed; top: 0; left: 0; 
//   transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, border-color 0.3s ease;
//   z-index: 110; box-shadow: 8px 0 30px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column; overflow: hidden;
// `;
// const SidebarInner = styled.div`display: flex; flex-direction: column; height: 100%;`;
// const SidebarHeader = styled.div`
//   background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   padding: ${({ collapsed }) => (collapsed ? "16px 14px 20px" : "16px 20px 20px")};
//   display: flex; flex-direction: column; gap: 16px; transition: all 0.3s ease;
//   border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f1f5f9'}; 
//   box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08); z-index: 10;
// `;
// const LogoWrap = styled.div`
//   display: ${({ collapsed }) => (collapsed ? "none" : "flex")}; justify-content: center; align-items: center; width: 100%; margin-top: -2px;
//   img { height: 40px; width: 100%; max-width: 220px; object-fit: contain; }
// `;
// const NavScroll = styled.div`
//   flex: 1; overflow-y: auto; overflow-x: hidden; padding: 14px 12px 14px; scroll-behavior: smooth;
//   scrollbar-width: thin; scrollbar-color: #60a5fa rgba(0, 0, 0, 0.05);
//   &::-webkit-scrollbar { width: 10px; }
//   &::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.04); border-radius: 999px; }
//   &::-webkit-scrollbar-thumb { background: linear-gradient(180deg, #60a5fa, #2563eb); border-radius: 999px; cursor: grab; }
//   &::-webkit-scrollbar-thumb:hover { background: linear-gradient(180deg, #3b82f6, #1d4ed8); }
// `;
// const ProfileRow = styled.div`
//   display: flex; align-items: center; justify-content: ${({ collapsed }) => (collapsed ? "center" : "space-between")};
//   flex-direction: ${({ collapsed }) => (collapsed ? "column" : "row")}; gap: ${({ collapsed }) => (collapsed ? "24px" : "0")}; width: 100%;
// `;
// const ProfileGroup = styled.div` display: flex; align-items: center; gap: 14px; `;
// const AvatarBox = styled.div`
//   width: 46px; height: 46px; border-radius: 14px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff'}; 
//   display: grid; place-items: center; font-weight: 800; font-size: 1.1rem; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; 
//   flex-shrink: 0; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); overflow: hidden; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : '#e0e7ff'};
//   img { width: 100%; height: 100%; object-fit: cover; }
// `;
// const BrandTextWrap = styled.div`
//   min-width: 0; transition: opacity 0.2s ease;
//   ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none; visibility: hidden;` : `position: relative; opacity: 1; pointer-events: auto; visibility: visible;`}
// `;
// const Username = styled.div` font-size: 13px; opacity: 0.95; font-weight: 700; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; `;
// const UserRole = styled.div` font-size: 11.5px; color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'}; margin-top: 2px; white-space: nowrap; font-weight: 500; `;
// const DateText = styled.div` font-size: 11px; color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#94a3b8'}; margin-top: 2px; white-space: nowrap; `;
// const ActiveStatus = styled.div`
//   display: flex; align-items: center; gap: 6px; font-size: 11.5px; margin-top: 4px; color: ${({ $isDarkMode }) => $isDarkMode ? '#4ade80' : '#16a34a'}; font-weight: 700;
//   span { width: 7px; height: 7px; background-color: #22c55e; border-radius: 50%; display: inline-block; box-shadow: 0 0 6px rgba(34, 197, 94, 0.4); }
// `;
// const ToggleBtn = styled.button`
//   background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; border-radius: 999px; width: 36px; height: 36px; display: grid; place-items: center; cursor: pointer; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); transition: all 0.2s ease; flex-shrink: 0;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#f8fafc'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; border-color: ${({ $isDarkMode }) => $isDarkMode ? '#475569' : '#cbd5e1'}; transform: scale(1.05); }
// `;
// const Menu = styled.nav` display: flex; flex-direction: column; gap: 6px; `;
// const Item = styled(NavLink)`
//   display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; justify-content: flex-start; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; text-decoration: none; transition: all 0.22s ease; position: relative; border-radius: 16px;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#f8fbff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; transform: translateX(2px); }
//   &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05))' : 'linear-gradient(135deg, #eff6ff, #f8fbff)'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; font-weight: 700; box-shadow: inset 0 0 0 1px ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : 'rgba(147, 197, 253, 0.2)'}; }
//   &.active::before { content: ""; position: absolute; left: 0; top: 10px; bottom: 10px; width: 4px; border-radius: 999px; background: linear-gradient(180deg, #2563eb, #60a5fa); }
//   ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; justify-content: center; &:hover { transform: none; } &.active { box-shadow: none; } &.active::before { left: 4px; top: 12px; bottom: 12px; }`}
// `;
// const IconWrap = styled.div` font-size: 19px; min-width: 22px; width: 22px; display: flex; align-items: center; justify-content: center; `;
// const Label = styled.span`
//   font-size: 14.6px; line-height: 1.3; white-space: nowrap; transition: opacity 0.2s ease;
//   ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none;` : `position: relative; opacity: 1; pointer-events: auto;`}
// `;
// const Tooltip = styled.span`
//   position: absolute; left: 86px; background: ${({ $isDarkMode }) => $isDarkMode ? '#ffffff' : '#0f172a'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'};
//   padding: 8px 12px; border-radius: 10px; font-size: 12.5px; white-space: nowrap; opacity: 0; pointer-events: none; box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2); transition: all 0.18s ease; z-index: 30; line-height: 1.3;
//   ${Item}:hover & { opacity: 1; transform: translateX(8px); }
// `;
// const BottomArea = styled.div` padding: 12px; border-top: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#eef2f7'}; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.9)' : 'rgba(255, 255, 255, 0.9)'}; transition: all 0.3s ease; `;
// const LogoutButton = styled.button`
//   display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; justify-content: flex-start; border: none; background: transparent; color: ${({ $isDarkMode }) => $isDarkMode ? '#ef4444' : '#b91c1c'}; border-radius: 16px; font-weight: 700; cursor: pointer; transition: all 0.22s ease; position: relative;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; transform: translateX(2px); }
//   ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; justify-content: center; &:hover { transform: none; }`}
// `;

// /* ================= MOBILE NAV STYLES ================= */
// const Topbar = styled.header` height: 72px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.96)' : 'rgba(255, 255, 255, 0.96)'}; backdrop-filter: blur(12px); border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e5e7eb'}; display: flex; align-items: center; justify-content: space-between; padding: 0 16px; position: fixed; top: 0; left: 0; width: 100%; z-index: 220; box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); transition: all 0.3s ease; @media (min-width: 1024px) { display: none; } `;
// const TopbarLeft = styled.div` display: flex; align-items: center; gap: 16px; min-width: 0; flex: 1; `;
// const TopbarAvatarBox = styled(AvatarBox)` width: 42px; height: 42px; border-radius: 12px; font-size: 1rem; `;
// const MenuToggle = styled.button` appearance: none; border: none; background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f8fafc'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; width: 42px; height: 42px; border-radius: 12px; display: grid; place-items: center; cursor: pointer; flex-shrink: 0; transition: all 0.3s ease; `;
// const Backdrop = styled.div` position: fixed; inset: 72px 0 0 0; background: rgba(15, 23, 42, 0.6); opacity: ${({ show }) => (show ? "1" : "0")}; pointer-events: ${({ show }) => (show ? "auto" : "none")}; transition: opacity 0.25s ease; z-index: 180; `;
// const MobileMenu = styled.aside` position: fixed; top: 72px; left: 0; width: min(88vw, 360px); height: calc(100vh - 72px); background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'}; transform: ${({ show }) => show ? "translateX(0)" : "translateX(-105%)"}; transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1), background 0.3s ease; z-index: 200; padding: 16px 14px 20px; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3); overflow-y: auto; `;
// const MobileHeader = styled.div` background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; border-radius: 16px; padding: 14px; margin-bottom: 20px; display: flex; flex-direction: column; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); transition: all 0.3s ease; `;
// const MobileHeaderTop = styled.div` display: flex; align-items: center; gap: 12px; `;
// const MobileAvatar = styled(AvatarBox)` width: 48px; height: 48px; border-radius: 50%; font-size: 1rem; `;
// const MobileMenuList = styled.nav` display: grid; gap: 8px; `;
// const MobileItem = styled(NavLink)` display: flex; align-items: center; gap: 14px; padding: 14px 14px; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; text-decoration: none; font-size: 15px; font-weight: 600; border-radius: 16px; line-height: 1.3; transition: all 0.2s ease; &:hover, &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#eff6ff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; } `;
// const MobileLogout = styled.button` margin-top: 12px; width: 100%; display: flex; align-items: center; gap: 14px; padding: 14px 14px; border: none; border-radius: 16px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#fca5a5' : '#b91c1c'}; font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'}; } `;

// const backendUrl = "https://api.stdl.site";  

// /* ================= COMPONENT ================= */
// const Navbar = ({ user, collapsed, setCollapsed }) => {
//   const isMobile = useMediaQuery({ maxWidth: 1023 });
//   const [showMobile, setShowMobile] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation(); 
//   const scrollContainerRef = useRef(null);
  
//   const handleScroll = (e) => {
//     sessionStorage.setItem("sidebarScrollPos", e.target.scrollTop);
//   };

//   const { isDarkMode } = useTheme();

//   const [profileData, setProfileData] = useState({ picture: "" });

//   useEffect(() => {
//     setProfileData({ picture: user?.profilePicture || "" });
//   }, [user]);

//   const currentDate = new Date().toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
//   const displayName = useMemo(() => user?.username || user?.name || "Welcome", [user]);

//   const displayRole = useMemo(() => {
//     if (!user || !user.role) return "Staff";
//     const dbRole = String(user.role).trim();
//     return dbRole.charAt(0).toUpperCase() + dbRole.slice(1).toLowerCase();
//   }, [user]);

//   const initials = useMemo(() => {
//     const source = user?.username || user?.name || user?.firstName || "U";
//     return source.split(" ").map((part) => part[0]).slice(0, 2).join("").toUpperCase();
//   }, [user]);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     localStorage.removeItem("session_expires_at");
//     sessionStorage.removeItem("fromCommandCenter"); // Clear breadcrumb on logout!
//     navigate("/");
//     window.location.reload();
//   };

//   const isSupervisor = useMemo(() => {
//     if (!user) return false;
//     const roleString = String(user.role || "").toLowerCase().trim();
//     if (roleString === "supervisor" || roleString === "superadmin" || roleString === "super_admin") return true;
//     if (Array.isArray(user.roles)) {
//       return user.roles.some(r => {
//         const rStr = String(r).toLowerCase().trim();
//         return rStr === "supervisor" || rStr === "superadmin" || rStr === "super_admin";
//       });
//     }
//     return false;
//   }, [user]);

//   // 🔥 NEW LOGIC: Look for the breadcrumb! 
//   // It ONLY shows if they clicked the Switch button from the Supervisor Dashboard.
//   const fromCommandCenter = sessionStorage.getItem('fromCommandCenter') === 'true';
//   const showCommandCenter = isSupervisor && fromCommandCenter && !location.pathname.includes('/supervisor');

//   // 🔥 Action to return: Clears the breadcrumb so it hides again when they leave.
//   const handleReturnToCommandCenter = (e) => {
//     e.preventDefault();
//     sessionStorage.removeItem('fromCommandCenter');
//     setShowMobile(false);
//     navigate('/supervisor');
//   };

//   // Mobile View
//   if (isMobile) {
//     return (
//       <>
//         <Topbar $isDarkMode={isDarkMode}>
//           <TopbarLeft>
//             <TopbarAvatarBox $isDarkMode={isDarkMode}>
//               {profileData.picture ? (
//                 <img 
//                   src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                   alt="Profile" 
//                   onError={(e) => { e.target.style.display = "none"; }}
//                 />
//               ) : ( initials )}
//             </TopbarAvatarBox>
//             <div style={{ fontSize: "1.1rem", fontWeight: 800, letterSpacing: "-0.03em", color: isDarkMode ? "#f8fafc" : "#0f172a", marginLeft: "-9px" }}>
//               <span style={{ color: "#3b82f6" }}>SPIRITMAN</span>Online
//             </div>
//           </TopbarLeft>
//           <MenuToggle $isDarkMode={isDarkMode} onClick={() => setShowMobile((prev) => !prev)}>
//             {showMobile ? <FaTimes size={18} /> : <FaBars size={18} />}
//           </MenuToggle>
//         </Topbar>

//         <Backdrop show={showMobile} onClick={() => setShowMobile(false)} />

//         <MobileMenu show={showMobile} $isDarkMode={isDarkMode}>
//           <MobileHeader $isDarkMode={isDarkMode}>
//             <MobileHeaderTop>
//               <MobileAvatar $isDarkMode={isDarkMode}>
//                 {profileData.picture ? (
//                   <img 
//                     src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                     alt="Profile" 
//                     onError={(e) => e.target.style.display = "none"}
//                   />
//                 ) : ( initials )}
//               </MobileAvatar>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
//                 <div style={{ fontWeight: 800, fontSize: "15px", lineHeight: "1.1", color: isDarkMode ? "#f8fafc" : "#0f172a" }}>
//                   {displayName}
//                 </div>
//                 <div style={{ fontSize: "12px", color: isDarkMode ? "#94a3b8" : "#64748b", margin: 0 }}>
//                   {displayRole}
//                 </div>
//                 <div style={{ fontSize: "11px", color: isDarkMode ? "#64748b" : "#94a3b8" }}>{currentDate}</div>
//                 <ActiveStatus $isDarkMode={isDarkMode} style={{ fontSize: "11.5px", marginTop: "2px" }}>
//                   <span /> Active
//                 </ActiveStatus>
//               </div>
//             </MobileHeaderTop>
//           </MobileHeader>

//           <MobileMenuList>
//             {showCommandCenter && (
//               <MobileItem
//                 $isDarkMode={isDarkMode}
//                 to="/supervisor"
//                 onClick={handleReturnToCommandCenter}
//                 style={{ background: '#2563eb', color: 'white', marginBottom: '8px' }}
//               >
//                 <FaShieldAlt /> Command Center
//               </MobileItem>
//             )}

//             {navItems.map((item) => (
//               <MobileItem $isDarkMode={isDarkMode} key={item.to} to={item.to} onClick={() => setShowMobile(false)}>
//                 {item.icon} {item.label}
//               </MobileItem>
//             ))}
//           </MobileMenuList>

//           <MobileLogout $isDarkMode={isDarkMode} onClick={() => { handleLogout(); setShowMobile(false); }}>
//             <FaSignOutAlt /> Logout
//           </MobileLogout>
//         </MobileMenu>
//       </>
//     );
//   }

//   // Desktop Sidebar View
//   return (
//     <Sidebar collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//       <SidebarInner>
//         <SidebarHeader collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//           <LogoWrap collapsed={collapsed ? 1 : 0} style={{ justifyContent: "center" }}>
//             <div style={{ fontSize: "1.4rem", fontWeight: 800, letterSpacing: "-0.03em", color: isDarkMode ? "#f8fafc" : "#0f172a" }}>
//               <span style={{ color: "#3b82f6" }}>SPIRITMAN</span>Online
//             </div>
//           </LogoWrap>

//           <ProfileRow collapsed={collapsed ? 1 : 0}>
//             <ProfileGroup>
//               <AvatarBox $isDarkMode={isDarkMode}>
//                 {profileData.picture ? (
//                   <img 
//                     src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                     alt="Profile" 
//                     onError={(e) => { e.target.style.display = "none"; }}
//                   />
//                 ) : ( initials )}
//               </AvatarBox>

//               <BrandTextWrap collapsed={collapsed ? 1 : 0}>
//                 <Username $isDarkMode={isDarkMode}>{displayName}</Username>
//                 <UserRole $isDarkMode={isDarkMode}>
//                   {displayRole}
//                 </UserRole>
//                 <DateText $isDarkMode={isDarkMode}>{currentDate}</DateText>
//                 <ActiveStatus $isDarkMode={isDarkMode}><span /> Active</ActiveStatus>
//               </BrandTextWrap>
//             </ProfileGroup>

//             <ToggleBtn $isDarkMode={isDarkMode} onClick={() => setCollapsed(!collapsed)}>
//               <FaBars size={14} />
//             </ToggleBtn>
//           </ProfileRow>
//         </SidebarHeader>

//         <NavScroll ref={scrollContainerRef} onScroll={handleScroll}>
//           <Menu>
//             {showCommandCenter && (
//               <Item 
//                 to="/supervisor" 
//                 collapsed={collapsed ? 1 : 0} 
//                 $isDarkMode={isDarkMode}
//                 onClick={handleReturnToCommandCenter}
//                 style={{ background: '#2563eb', color: 'white', marginBottom: '12px' }}
//               >
//                 <IconWrap><FaShieldAlt /></IconWrap>
//                 <Label collapsed={collapsed ? 1 : 0}>Command Center</Label>
//                 {collapsed && <Tooltip $isDarkMode={isDarkMode}>Command Center</Tooltip>}
//               </Item>
//             )}

//             {navItems.map((item) => (
//               <Item key={item.to} to={item.to} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//                 <IconWrap>{item.icon}</IconWrap>
//                 <Label collapsed={collapsed ? 1 : 0}>{item.label}</Label>
//                 {collapsed && <Tooltip $isDarkMode={isDarkMode}>{item.label}</Tooltip>}
//               </Item>
//             ))}
//           </Menu>
//         </NavScroll>

//         <BottomArea $isDarkMode={isDarkMode}>
//           <LogoutButton onClick={handleLogout} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//             <IconWrap><FaSignOutAlt /></IconWrap>
//             <Label collapsed={collapsed ? 1 : 0}>Logout</Label>
//             {collapsed && <Tooltip $isDarkMode={isDarkMode}>Logout</Tooltip>}
//           </LogoutButton>
//         </BottomArea>
//       </SidebarInner>
//     </Sidebar>
//   );
// };

// export default Navbar;








// import React, { useMemo, useState, useRef, useEffect } from "react";
// import styled from "styled-components";
// import { NavLink, useNavigate, useLocation } from "react-router-dom";
// import { useMediaQuery } from "react-responsive";
// import {
//   FaBars,
//   FaTimes,
//   FaUserCircle,
//   FaBullseye,
//   FaChartLine,
//   FaHandsHelping,
//   FaShieldAlt,
//   FaClipboardList,
//   FaFolderOpen,
//   FaCog,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import { useTheme } from "../App"; 

// /* ================= DATA ================= */
// const navItems = [
//   { to: "/dashboard", label: "Dashboard", icon: <FaBullseye /> },
//   { to: "/live", label: "Live", icon: <FaChartLine /> },
//   {
//     to: "/training",
//     label: "Messages",
//     icon: <FaHandsHelping />,
//   },
//   { to: "/message", label: "Discipleship", icon: <FaShieldAlt /> },
//   {
//     to: "/discipleship",
//     label: "My Custom Trainings",
//     icon: <FaClipboardList />,
//   },
//   { to: "/settings", label: "Settings", icon: <FaCog /> },
// ];

// /* ================= STYLED COMPONENTS ================= */
// // ... (Keep all your existing styled-components exactly as they are)
// const Sidebar = styled.aside`
//   width: ${({ collapsed }) => (collapsed ? "88px" : "280px")};
//   height: 100vh;
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(30, 41, 59, 0.96)' : 'rgba(255, 255, 255, 0.96)'};
//   backdrop-filter: blur(12px);
//   border-right: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.9)'};
//   position: fixed; top: 0; left: 0; 
//   transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, border-color 0.3s ease;
//   z-index: 110; box-shadow: 8px 0 30px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column; overflow: hidden;
// `;
// const SidebarInner = styled.div`display: flex; flex-direction: column; height: 100%;`;
// const SidebarHeader = styled.div`
//   background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   padding: ${({ collapsed }) => (collapsed ? "16px 14px 20px" : "16px 20px 20px")};
//   display: flex; flex-direction: column; gap: 16px; transition: all 0.3s ease;
//   border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f1f5f9'}; 
//   box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08); z-index: 10;
// `;
// const LogoWrap = styled.div`
//   display: ${({ collapsed }) => (collapsed ? "none" : "flex")}; justify-content: center; align-items: center; width: 100%; margin-top: -2px;
//   img { height: 40px; width: 100%; max-width: 220px; object-fit: contain; }
// `;
// const NavScroll = styled.div`
//   flex: 1; overflow-y: auto; overflow-x: hidden; padding: 14px 12px 14px; scroll-behavior: smooth;
//   scrollbar-width: thin; scrollbar-color: #60a5fa rgba(0, 0, 0, 0.05);
//   &::-webkit-scrollbar { width: 10px; }
//   &::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.04); border-radius: 999px; }
//   &::-webkit-scrollbar-thumb { background: linear-gradient(180deg, #60a5fa, #2563eb); border-radius: 999px; cursor: grab; }
//   &::-webkit-scrollbar-thumb:hover { background: linear-gradient(180deg, #3b82f6, #1d4ed8); }
// `;
// const ProfileRow = styled.div`
//   display: flex; align-items: center; justify-content: ${({ collapsed }) => (collapsed ? "center" : "space-between")};
//   flex-direction: ${({ collapsed }) => (collapsed ? "column" : "row")}; gap: ${({ collapsed }) => (collapsed ? "24px" : "0")}; width: 100%;
// `;
// const ProfileGroup = styled.div` display: flex; align-items: center; gap: 14px; `;
// const AvatarBox = styled.div`
//   width: 46px; height: 46px; border-radius: 14px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff'}; 
//   display: grid; place-items: center; font-weight: 800; font-size: 1.1rem; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; 
//   flex-shrink: 0; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); overflow: hidden; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : '#e0e7ff'};
//   img { width: 100%; height: 100%; object-fit: cover; }
// `;
// const BrandTextWrap = styled.div`
//   min-width: 0; transition: opacity 0.2s ease;
//   ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none; visibility: hidden;` : `position: relative; opacity: 1; pointer-events: auto; visibility: visible;`}
// `;
// const Username = styled.div` font-size: 13px; opacity: 0.95; font-weight: 700; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; `;
// const UserRole = styled.div` font-size: 11.5px; color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'}; margin-top: 2px; white-space: nowrap; font-weight: 500; `;
// const DateText = styled.div` font-size: 11px; color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#94a3b8'}; margin-top: 2px; white-space: nowrap; `;
// const ActiveStatus = styled.div`
//   display: flex; align-items: center; gap: 6px; font-size: 11.5px; margin-top: 4px; color: ${({ $isDarkMode }) => $isDarkMode ? '#4ade80' : '#16a34a'}; font-weight: 700;
//   span { width: 7px; height: 7px; background-color: #22c55e; border-radius: 50%; display: inline-block; box-shadow: 0 0 6px rgba(34, 197, 94, 0.4); }
// `;
// const ToggleBtn = styled.button`
//   background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; border-radius: 999px; width: 36px; height: 36px; display: grid; place-items: center; cursor: pointer; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); transition: all 0.2s ease; flex-shrink: 0;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#f8fafc'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; border-color: ${({ $isDarkMode }) => $isDarkMode ? '#475569' : '#cbd5e1'}; transform: scale(1.05); }
// `;
// const Menu = styled.nav` display: flex; flex-direction: column; gap: 6px; `;
// const Item = styled(NavLink)`
//   display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; justify-content: flex-start; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; text-decoration: none; transition: all 0.22s ease; position: relative; border-radius: 16px;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#f8fbff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; transform: translateX(2px); }
//   &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05))' : 'linear-gradient(135deg, #eff6ff, #f8fbff)'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; font-weight: 700; box-shadow: inset 0 0 0 1px ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : 'rgba(147, 197, 253, 0.2)'}; }
//   &.active::before { content: ""; position: absolute; left: 0; top: 10px; bottom: 10px; width: 4px; border-radius: 999px; background: linear-gradient(180deg, #2563eb, #60a5fa); }
//   ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; justify-content: center; &:hover { transform: none; } &.active { box-shadow: none; } &.active::before { left: 4px; top: 12px; bottom: 12px; }`}
// `;
// const IconWrap = styled.div` font-size: 19px; min-width: 22px; width: 22px; display: flex; align-items: center; justify-content: center; `;
// const Label = styled.span`
//   font-size: 14.6px; line-height: 1.3; white-space: nowrap; transition: opacity 0.2s ease;
//   ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none;` : `position: relative; opacity: 1; pointer-events: auto;`}
// `;
// const Tooltip = styled.span`
//   position: absolute; left: 86px; background: ${({ $isDarkMode }) => $isDarkMode ? '#ffffff' : '#0f172a'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'};
//   padding: 8px 12px; border-radius: 10px; font-size: 12.5px; white-space: nowrap; opacity: 0; pointer-events: none; box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2); transition: all 0.18s ease; z-index: 30; line-height: 1.3;
//   ${Item}:hover & { opacity: 1; transform: translateX(8px); }
// `;
// const BottomArea = styled.div` padding: 12px; border-top: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#eef2f7'}; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.9)' : 'rgba(255, 255, 255, 0.9)'}; transition: all 0.3s ease; `;
// const LogoutButton = styled.button`
//   display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; justify-content: flex-start; border: none; background: transparent; color: ${({ $isDarkMode }) => $isDarkMode ? '#ef4444' : '#b91c1c'}; border-radius: 16px; font-weight: 700; cursor: pointer; transition: all 0.22s ease; position: relative;
//   &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; transform: translateX(2px); }
//   ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; justify-content: center; &:hover { transform: none; }`}
// `;

// const Topbar = styled.header` height: 72px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.96)' : 'rgba(255, 255, 255, 0.96)'}; backdrop-filter: blur(12px); border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e5e7eb'}; display: flex; align-items: center; justify-content: space-between; padding: 0 16px; position: fixed; top: 0; left: 0; width: 100%; z-index: 220; box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); transition: all 0.3s ease; @media (min-width: 1024px) { display: none; } `;
// const TopbarLeft = styled.div` display: flex; align-items: center; gap: 16px; min-width: 0; flex: 1; `;
// const TopbarAvatarBox = styled(AvatarBox)` width: 42px; height: 42px; border-radius: 12px; font-size: 1rem; `;
// const MenuToggle = styled.button` appearance: none; border: none; background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f8fafc'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; width: 42px; height: 42px; border-radius: 12px; display: grid; place-items: center; cursor: pointer; flex-shrink: 0; transition: all 0.3s ease; `;
// const Backdrop = styled.div` position: fixed; inset: 72px 0 0 0; background: rgba(15, 23, 42, 0.6); opacity: ${({ show }) => (show ? "1" : "0")}; pointer-events: ${({ show }) => (show ? "auto" : "none")}; transition: opacity 0.25s ease; z-index: 180; `;
// const MobileMenu = styled.aside` position: fixed; top: 72px; left: 0; width: min(88vw, 360px); height: calc(100vh - 72px); background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'}; transform: ${({ show }) => show ? "translateX(0)" : "translateX(-105%)"}; transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1), background 0.3s ease; z-index: 200; padding: 16px 14px 20px; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3); overflow-y: auto; `;
// const MobileHeader = styled.div` background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; border-radius: 16px; padding: 14px; margin-bottom: 20px; display: flex; flex-direction: column; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); transition: all 0.3s ease; `;
// const MobileHeaderTop = styled.div` display: flex; align-items: center; gap: 12px; `;
// const MobileAvatar = styled(AvatarBox)` width: 48px; height: 48px; border-radius: 50%; font-size: 1rem; `;
// const MobileMenuList = styled.nav` display: grid; gap: 8px; `;
// const MobileItem = styled(NavLink)` display: flex; align-items: center; gap: 14px; padding: 14px 14px; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; text-decoration: none; font-size: 15px; font-weight: 600; border-radius: 16px; line-height: 1.3; transition: all 0.2s ease; &:hover, &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#eff6ff'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; } `;
// const MobileLogout = styled.button` margin-top: 12px; width: 100%; display: flex; align-items: center; gap: 14px; padding: 14px 14px; border: none; border-radius: 16px; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; color: ${({ $isDarkMode }) => $isDarkMode ? '#fca5a5' : '#b91c1c'}; font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'}; } `;

// const backendUrl = "https://api.stdl.site";  

// /* ================= COMPONENT ================= */
// const Navbar = ({ user, collapsed, setCollapsed }) => {
//   const isMobile = useMediaQuery({ maxWidth: 1023 });
//   const [showMobile, setShowMobile] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation(); 
//   const scrollContainerRef = useRef(null);
  
//   // 🔥 AUTO-SCROLL TO TOP ON ROUTE CHANGE 🔥
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "instant", // Snaps to the top immediately without a sliding animation
//     });
//   }, [location.pathname]); // This triggers every time the path changes

//   const handleScroll = (e) => {
//     sessionStorage.setItem("sidebarScrollPos", e.target.scrollTop);
//   };

//   const { isDarkMode } = useTheme();

//   const [profileData, setProfileData] = useState({ picture: "" });

//   useEffect(() => {
//     setProfileData({ picture: user?.profilePicture || "" });
//   }, [user]);

//   const currentDate = new Date().toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
//   const displayName = useMemo(() => user?.username || user?.name || "Welcome", [user]);

//   const displayRole = useMemo(() => {
//     if (!user || !user.role) return "Staff";
//     const dbRole = String(user.role).trim();
//     return dbRole.charAt(0).toUpperCase() + dbRole.slice(1).toLowerCase();
//   }, [user]);

//   const initials = useMemo(() => {
//     const source = user?.username || user?.name || user?.firstName || "U";
//     return source.split(" ").map((part) => part[0]).slice(0, 2).join("").toUpperCase();
//   }, [user]);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     localStorage.removeItem("session_expires_at");
//     sessionStorage.removeItem("fromCommandCenter"); 
//     navigate("/");
//     window.location.reload();
//   };

//   const isSupervisor = useMemo(() => {
//     if (!user) return false;
//     const roleString = String(user.role || "").toLowerCase().trim();
//     if (roleString === "supervisor" || roleString === "superadmin" || roleString === "super_admin") return true;
//     if (Array.isArray(user.roles)) {
//       return user.roles.some(r => {
//         const rStr = String(r).toLowerCase().trim();
//         return rStr === "supervisor" || rStr === "superadmin" || rStr === "super_admin";
//       });
//     }
//     return false;
//   }, [user]);

//   const fromCommandCenter = sessionStorage.getItem('fromCommandCenter') === 'true';
//   const showCommandCenter = isSupervisor && fromCommandCenter && !location.pathname.includes('/supervisor');

//   const handleReturnToCommandCenter = (e) => {
//     e.preventDefault();
//     sessionStorage.removeItem('fromCommandCenter');
//     setShowMobile(false);
//     navigate('/supervisor');
//   };

//   if (isMobile) {
//     return (
//       <>
//         <Topbar $isDarkMode={isDarkMode}>
//           <TopbarLeft>
//             <TopbarAvatarBox $isDarkMode={isDarkMode}>
//               {profileData.picture ? (
//                 <img 
//                   src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                   alt="Profile" 
//                   onError={(e) => { e.target.style.display = "none"; }}
//                 />
//               ) : ( initials )}
//             </TopbarAvatarBox>
            
//             <div style={{ fontSize: "1.1rem", fontWeight: 800, letterSpacing: "-0.03em", color: isDarkMode ? "#f8fafc" : "#0f172a", marginLeft: "-9px" }}>
//               <span style={{ color: "#3b82f6" }}>SPIRITMAN</span>Online
//             </div>
//           </TopbarLeft>
//           <MenuToggle $isDarkMode={isDarkMode} onClick={() => setShowMobile((prev) => !prev)}>
//             {showMobile ? <FaTimes size={18} /> : <FaBars size={18} />}
//           </MenuToggle>
//         </Topbar>

//         <Backdrop show={showMobile} onClick={() => setShowMobile(false)} />

//         <MobileMenu show={showMobile} $isDarkMode={isDarkMode}>
//           <MobileHeader $isDarkMode={isDarkMode}>
//             <MobileHeaderTop>
//               <MobileAvatar $isDarkMode={isDarkMode}>
//                 {profileData.picture ? (
//                   <img 
//                     src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                     alt="Profile" 
//                     onError={(e) => e.target.style.display = "none"}
//                   />
//                 ) : ( initials )}
//               </MobileAvatar>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
//                 <div style={{ fontWeight: 800, fontSize: "15px", lineHeight: "1.1", color: isDarkMode ? "#f8fafc" : "#0f172a" }}>
//                   {displayName}
//                 </div>
//                 <div style={{ fontSize: "12px", color: isDarkMode ? "#94a3b8" : "#64748b", margin: 0 }}>
//                   {displayRole}
//                 </div>
//                 <div style={{ fontSize: "11px", color: isDarkMode ? "#64748b" : "#94a3b8" }}>{currentDate}</div>
//                 <ActiveStatus $isDarkMode={isDarkMode} style={{ fontSize: "11.5px", marginTop: "2px" }}>
//                   <span /> Active
//                 </ActiveStatus>
//               </div>
//             </MobileHeaderTop>
//           </MobileHeader>

//           <MobileMenuList>
//             {showCommandCenter && (
//               <MobileItem
//                 $isDarkMode={isDarkMode}
//                 to="/supervisor"
//                 onClick={handleReturnToCommandCenter}
//                 style={{ background: '#2563eb', color: 'white', marginBottom: '8px' }}
//               >
//                 <FaShieldAlt /> Command Center
//               </MobileItem>
//             )}

//             {navItems.map((item) => (
//               <MobileItem $isDarkMode={isDarkMode} key={item.to} to={item.to} onClick={() => setShowMobile(false)}>
//                 {item.icon} {item.label}
//               </MobileItem>
//             ))}
//           </MobileMenuList>

//           <MobileLogout $isDarkMode={isDarkMode} onClick={() => { handleLogout(); setShowMobile(false); }}>
//             <FaSignOutAlt /> Logout
//           </MobileLogout>
//         </MobileMenu>
//       </>
//     );
//   }

//   // Desktop Sidebar View
//   return (
//     <Sidebar collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//       <SidebarInner>
//         <SidebarHeader collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//           <LogoWrap collapsed={collapsed ? 1 : 0} style={{ justifyContent: "center" }}>
//             <div style={{ fontSize: "1.4rem", fontWeight: 800, letterSpacing: "-0.03em", color: isDarkMode ? "#f8fafc" : "#0f172a" }}>
//               <span style={{ color: "#3b82f6" }}>SPIRITMAN</span>Online
//             </div>
//           </LogoWrap>

//           <ProfileRow collapsed={collapsed ? 1 : 0}>
//             <ProfileGroup>
//               <AvatarBox $isDarkMode={isDarkMode}>
//                 {profileData.picture ? (
//                   <img 
//                     src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
//                     alt="Profile" 
//                     onError={(e) => { e.target.style.display = "none"; }}
//                   />
//                 ) : ( initials )}
//               </AvatarBox>

//               <BrandTextWrap collapsed={collapsed ? 1 : 0}>
//                 <Username $isDarkMode={isDarkMode}>{displayName}</Username>
//                 <UserRole $isDarkMode={isDarkMode}>
//                   {displayRole}
//                 </UserRole>
//                 <DateText $isDarkMode={isDarkMode}>{currentDate}</DateText>
//                 <ActiveStatus $isDarkMode={isDarkMode}><span /> Active</ActiveStatus>
//               </BrandTextWrap>
//             </ProfileGroup>

//             <ToggleBtn $isDarkMode={isDarkMode} onClick={() => setCollapsed(!collapsed)}>
//               <FaBars size={14} />
//             </ToggleBtn>
//           </ProfileRow>
//         </SidebarHeader>

//         <NavScroll ref={scrollContainerRef} onScroll={handleScroll}>
//           <Menu>
//             {showCommandCenter && (
//               <Item 
//                 to="/supervisor" 
//                 collapsed={collapsed ? 1 : 0} 
//                 $isDarkMode={isDarkMode}
//                 onClick={handleReturnToCommandCenter}
//                 style={{ background: '#2563eb', color: 'white', marginBottom: '12px' }}
//               >
//                 <IconWrap><FaShieldAlt /></IconWrap>
//                 <Label collapsed={collapsed ? 1 : 0}>Command Center</Label>
//                 {collapsed && <Tooltip $isDarkMode={isDarkMode}>Command Center</Tooltip>}
//               </Item>
//             )}

//             {navItems.map((item) => (
//               <Item key={item.to} to={item.to} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//                 <IconWrap>{item.icon}</IconWrap>
//                 <Label collapsed={collapsed ? 1 : 0}>{item.label}</Label>
//                 {collapsed && <Tooltip $isDarkMode={isDarkMode}>{item.label}</Tooltip>}
//               </Item>
//             ))}
//           </Menu>
//         </NavScroll>

//         <BottomArea $isDarkMode={isDarkMode}>
//           <LogoutButton onClick={handleLogout} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
//             <IconWrap><FaSignOutAlt /></IconWrap>
//             <Label collapsed={collapsed ? 1 : 0}>Logout</Label>
//             {collapsed && <Tooltip $isDarkMode={isDarkMode}>Logout</Tooltip>}
//           </LogoutButton>
//         </BottomArea>
//       </SidebarInner>
//     </Sidebar>
//   );
// };

// export default Navbar;



import React, { useMemo, useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  FaBars,
  FaTimes,
  FaUserCircle,
  FaBullseye,
  FaChartLine,
  FaHandsHelping,
  FaShieldAlt,
  FaClipboardList,
  FaFolderOpen,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";
import { useTheme } from "../App"; 
import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

/* ================= DATA ================= */
const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: <FaBullseye /> },
  { to: "/live", label: "Live", icon: <FaChartLine /> },
  {
    to: "/training",
    label: "Messages",
    icon: <FaHandsHelping />,
  },
  { to: "/message", label: "Discipleship", icon: <FaShieldAlt /> },
  {
    to: "/discipleship",
    label: "My Custom Trainings",
    icon: <FaClipboardList />,
  },
  { to: "/settings", label: "Settings", icon: <FaCog /> },
];

/* ================= STYLED COMPONENTS ================= */
const Sidebar = styled.aside`
  width: ${({ collapsed }) => (collapsed ? "88px" : "280px")};
  height: 100vh;
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(30, 41, 59, 0.96)' : 'rgba(255, 255, 255, 0.96)'};
  backdrop-filter: blur(12px);
  border-right: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.9)'};
  position: fixed; top: 0; left: 0; 
  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, border-color 0.3s ease;
  z-index: 110; box-shadow: 8px 0 30px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column; overflow: hidden;
`;

const SidebarInner = styled.div`display: flex; flex-direction: column; height: 100%;`;

const SidebarHeader = styled.div`
  background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  padding: ${({ collapsed }) => (collapsed ? "16px 14px 20px" : "16px 20px 20px")};
  display: flex; flex-direction: column; gap: 16px; transition: all 0.3s ease;
  border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f1f5f9'}; 
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08); z-index: 10;
`;

const LogoWrap = styled.div`
  display: ${({ collapsed }) => (collapsed ? "none" : "flex")}; 
  justify-content: center; 
  align-items: center; 
  width: 100%; 
  margin-top: -2px;
`;

const LogoImage = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    height: 40px;
  }
`;

const NavScroll = styled.div`
  flex: 1; overflow-y: auto; overflow-x: hidden; padding: 14px 12px 14px; scroll-behavior: smooth;
  scrollbar-width: thin; scrollbar-color: #60a5fa rgba(0, 0, 0, 0.05);
  &::-webkit-scrollbar { width: 10px; }
  &::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.04); border-radius: 999px; }
  &::-webkit-scrollbar-thumb { background: linear-gradient(180deg, #60a5fa, #2563eb); border-radius: 999px; cursor: grab; }
  &::-webkit-scrollbar-thumb:hover { background: linear-gradient(180deg, #3b82f6, #1d4ed8); }
`;

const ProfileRow = styled.div`
  display: flex; 
  align-items: center; 
  justify-content: ${({ collapsed }) => (collapsed ? "center" : "space-between")};
  flex-direction: ${({ collapsed }) => (collapsed ? "column" : "row")}; 
  gap: ${({ collapsed }) => (collapsed ? "24px" : "0")}; 
  width: 100%;
`;

const ProfileGroup = styled.div` 
  display: flex; 
  align-items: center; 
  gap: 14px; 
`;

const AvatarBox = styled.div`
  width: 46px; height: 46px; border-radius: 14px; 
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff'}; 
  display: grid; place-items: center; font-weight: 800; font-size: 1.1rem; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; 
  flex-shrink: 0; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); overflow: hidden; 
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : '#e0e7ff'};
  img { width: 100%; height: 100%; object-fit: cover; }
`;

const BrandTextWrap = styled.div`
  min-width: 0; transition: opacity 0.2s ease;
  ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none; visibility: hidden;` : `position: relative; opacity: 1; pointer-events: auto; visibility: visible;`}
`;

const Username = styled.div` 
  font-size: 13px; opacity: 0.95; font-weight: 700; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; 
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; 
`;

const UserRole = styled.div` 
  font-size: 11.5px; color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'}; 
  margin-top: 2px; white-space: nowrap; font-weight: 500; 
`;

const DateText = styled.div` 
  font-size: 11px; color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#94a3b8'}; 
  margin-top: 2px; white-space: nowrap; 
`;

const ActiveStatus = styled.div`
  display: flex; align-items: center; gap: 6px; font-size: 11.5px; margin-top: 4px; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#4ade80' : '#16a34a'}; font-weight: 700;
  span { width: 7px; height: 7px; background-color: #22c55e; border-radius: 50%; display: inline-block; box-shadow: 0 0 6px rgba(34, 197, 94, 0.4); }
`;

const ToggleBtn = styled.button`
  background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; 
  border-radius: 999px; width: 36px; height: 36px; display: grid; place-items: center; 
  cursor: pointer; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); transition: all 0.2s ease; flex-shrink: 0;
  &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#f8fafc'}; 
    color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; 
    border-color: ${({ $isDarkMode }) => $isDarkMode ? '#475569' : '#cbd5e1'}; transform: scale(1.05); }
`;

const Menu = styled.nav` display: flex; flex-direction: column; gap: 6px; `;

const Item = styled(NavLink)`
  display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; 
  justify-content: flex-start; color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; 
  text-decoration: none; transition: all 0.22s ease; position: relative; border-radius: 16px;
  &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#f8fbff'}; 
    color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; transform: translateX(2px); }
  &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05))' : 'linear-gradient(135deg, #eff6ff, #f8fbff)'}; 
    color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; font-weight: 700; 
    box-shadow: inset 0 0 0 1px ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.3)' : 'rgba(147, 197, 253, 0.2)'}; }
  &.active::before { content: ""; position: absolute; left: 0; top: 10px; bottom: 10px; 
    width: 4px; border-radius: 999px; background: linear-gradient(180deg, #2563eb, #60a5fa); }
  ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; 
    justify-content: center; &:hover { transform: none; } &.active { box-shadow: none; } 
    &.active::before { left: 4px; top: 12px; bottom: 12px; }`}
`;

const IconWrap = styled.div` 
  font-size: 19px; min-width: 22px; width: 22px; display: flex; align-items: center; justify-content: center; 
`;

const Label = styled.span`
  font-size: 14.6px; line-height: 1.3; white-space: nowrap; transition: opacity 0.2s ease;
  ${({ collapsed }) => collapsed ? `position: absolute; opacity: 0; pointer-events: none;` : `position: relative; opacity: 1; pointer-events: auto;`}
`;

const Tooltip = styled.span`
  position: absolute; left: 86px; background: ${({ $isDarkMode }) => $isDarkMode ? '#ffffff' : '#0f172a'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'};
  padding: 8px 12px; border-radius: 10px; font-size: 12.5px; white-space: nowrap; 
  opacity: 0; pointer-events: none; box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2); 
  transition: all 0.18s ease; z-index: 30; line-height: 1.3;
  ${Item}:hover & { opacity: 1; transform: translateX(8px); }
`;

const BottomArea = styled.div` 
  padding: 12px; border-top: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#eef2f7'}; 
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.9)' : 'rgba(255, 255, 255, 0.9)'}; 
  transition: all 0.3s ease; 
`;

const LogoutButton = styled.button`
  display: flex; align-items: center; gap: 14px; min-height: 50px; padding: 12px 14px; 
  justify-content: flex-start; border: none; background: transparent; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#ef4444' : '#b91c1c'}; border-radius: 16px; 
  font-weight: 700; cursor: pointer; transition: all 0.22s ease; position: relative;
  &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; transform: translateX(2px); }
  ${({ collapsed }) => collapsed && `width: 48px; min-height: 48px; padding: 0; gap: 0; margin: 0 auto; 
    justify-content: center; &:hover { transform: none; }`}
`;

const Topbar = styled.header` 
  height: 72px; 
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.96)' : 'rgba(255, 255, 255, 0.96)'}; 
  backdrop-filter: blur(12px); 
  border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e5e7eb'}; 
  display: flex; align-items: center; justify-content: space-between; 
  padding: 0 16px; position: fixed; top: 0; left: 0; width: 100%; z-index: 220; 
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); transition: all 0.3s ease; 
  @media (min-width: 1024px) { display: none; } 
`;

const TopbarLeft = styled.div` 
  display: flex; align-items: center; gap: 16px; min-width: 0; flex: 1; 
`;

const TopbarLogo = styled.img`
  height: 45px;
  width: auto;
  object-fit: contain;
  border-radius: 8px;
  
  @media (max-width: 480px) {
    height: 35px;
  }
`;

const TopbarAvatarBox = styled(AvatarBox)` 
  width: 42px; height: 42px; border-radius: 12px; font-size: 1rem; 
`;

const MenuToggle = styled.button` 
  appearance: none; border: none; 
  background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f8fafc'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; 
  width: 42px; height: 42px; border-radius: 12px; display: grid; place-items: center; 
  cursor: pointer; flex-shrink: 0; transition: all 0.3s ease; 
`;

const Backdrop = styled.div` 
  position: fixed; inset: 72px 0 0 0; background: rgba(15, 23, 42, 0.6); 
  opacity: ${({ show }) => (show ? "1" : "0")}; 
  pointer-events: ${({ show }) => (show ? "auto" : "none")}; 
  transition: opacity 0.25s ease; z-index: 180; 
`;

const MobileMenu = styled.aside` 
  position: fixed; top: 72px; left: 0; width: min(88vw, 360px); 
  height: calc(100vh - 72px); background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : 'white'}; 
  transform: ${({ show }) => show ? "translateX(0)" : "translateX(-105%)"}; 
  transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1), background 0.3s ease; 
  z-index: 200; padding: 16px 14px 20px; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3); 
  overflow-y: auto; 
`;

const MobileHeader = styled.div` 
  background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'}; 
  border-radius: 16px; padding: 14px; margin-bottom: 20px; 
  display: flex; flex-direction: column; 
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'}; 
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); transition: all 0.3s ease; 
`;

const MobileHeaderTop = styled.div` 
  display: flex; align-items: center; gap: 12px; 
`;

const MobileAvatar = styled(AvatarBox)` 
  width: 48px; height: 48px; border-radius: 50%; font-size: 1rem; 
`;

const MobileMenuList = styled.nav` display: grid; gap: 8px; `;

const MobileItem = styled(NavLink)` 
  display: flex; align-items: center; gap: 14px; padding: 14px 14px; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#cbd5e1' : '#334155'}; 
  text-decoration: none; font-size: 15px; font-weight: 600; border-radius: 16px; 
  line-height: 1.3; transition: all 0.2s ease; 
  &:hover, &.active { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(59, 130, 246, 0.1)' : '#eff6ff'}; 
    color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#1e40af'}; } 
`;

const MobileLogout = styled.button` 
  margin-top: 12px; width: 100%; display: flex; align-items: center; gap: 14px; 
  padding: 14px 14px; border: none; border-radius: 16px; 
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.1)' : '#fef2f2'}; 
  color: ${({ $isDarkMode }) => $isDarkMode ? '#fca5a5' : '#b91c1c'}; 
  font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; 
  &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'}; } 
`;

const backendUrl = "https://api.stdl.site";  

/* ================= COMPONENT ================= */
const Navbar = ({ user, collapsed, setCollapsed }) => {
  const isMobile = useMediaQuery({ maxWidth: 1023 });
  const [showMobile, setShowMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); 
  const scrollContainerRef = useRef(null);
  
  // 🔥 AUTO-SCROLL TO TOP ON ROUTE CHANGE 🔥
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [location.pathname]);

  const handleScroll = (e) => {
    sessionStorage.setItem("sidebarScrollPos", e.target.scrollTop);
  };

  const { isDarkMode } = useTheme();

  const [profileData, setProfileData] = useState({ picture: "" });

  useEffect(() => {
    setProfileData({ picture: user?.profilePicture || "" });
  }, [user]);

  const currentDate = new Date().toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const displayName = useMemo(() => user?.username || user?.name || "Welcome", [user]);

  const displayRole = useMemo(() => {
    if (!user || !user.role) return "Staff";
    const dbRole = String(user.role).trim();
    return dbRole.charAt(0).toUpperCase() + dbRole.slice(1).toLowerCase();
  }, [user]);

  const initials = useMemo(() => {
    const source = user?.username || user?.name || user?.firstName || "U";
    return source.split(" ").map((part) => part[0]).slice(0, 2).join("").toUpperCase();
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("session_expires_at");
    sessionStorage.removeItem("fromCommandCenter"); 
    navigate("/");
    window.location.reload();
  };

  const isSupervisor = useMemo(() => {
    if (!user) return false;
    const roleString = String(user.role || "").toLowerCase().trim();
    if (roleString === "supervisor" || roleString === "superadmin" || roleString === "super_admin") return true;
    if (Array.isArray(user.roles)) {
      return user.roles.some(r => {
        const rStr = String(r).toLowerCase().trim();
        return rStr === "supervisor" || rStr === "superadmin" || rStr === "super_admin";
      });
    }
    return false;
  }, [user]);

  const fromCommandCenter = sessionStorage.getItem('fromCommandCenter') === 'true';
  const showCommandCenter = isSupervisor && fromCommandCenter && !location.pathname.includes('/supervisor');

  const handleReturnToCommandCenter = (e) => {
    e.preventDefault();
    sessionStorage.removeItem('fromCommandCenter');
    setShowMobile(false);
    navigate('/supervisor');
  };

  if (isMobile) {
    return (
      <>
        <Topbar $isDarkMode={isDarkMode}>
          <TopbarLeft>
            <TopbarAvatarBox $isDarkMode={isDarkMode}>
              {profileData.picture ? (
                <img 
                  src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
                  alt="Profile" 
                  onError={(e) => { e.target.style.display = "none"; }}
                />
              ) : ( initials )}
            </TopbarAvatarBox>
            
            <TopbarLogo src={logo} alt="SPIRITMAN" />
          </TopbarLeft>
          <MenuToggle $isDarkMode={isDarkMode} onClick={() => setShowMobile((prev) => !prev)}>
            {showMobile ? <FaTimes size={18} /> : <FaBars size={18} />}
          </MenuToggle>
        </Topbar>

        <Backdrop show={showMobile} onClick={() => setShowMobile(false)} />

        <MobileMenu show={showMobile} $isDarkMode={isDarkMode}>
          <MobileHeader $isDarkMode={isDarkMode}>
            <MobileHeaderTop>
              <MobileAvatar $isDarkMode={isDarkMode}>
                {profileData.picture ? (
                  <img 
                    src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
                    alt="Profile" 
                    onError={(e) => e.target.style.display = "none"}
                  />
                ) : ( initials )}
              </MobileAvatar>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                <div style={{ fontWeight: 800, fontSize: "15px", lineHeight: "1.1", color: isDarkMode ? "#f8fafc" : "#0f172a" }}>
                  {displayName}
                </div>
                <div style={{ fontSize: "12px", color: isDarkMode ? "#94a3b8" : "#64748b", margin: 0 }}>
                  {displayRole}
                </div>
                <div style={{ fontSize: "11px", color: isDarkMode ? "#64748b" : "#94a3b8" }}>{currentDate}</div>
                <ActiveStatus $isDarkMode={isDarkMode} style={{ fontSize: "11.5px", marginTop: "2px" }}>
                  <span /> Active
                </ActiveStatus>
              </div>
            </MobileHeaderTop>
          </MobileHeader>

          <MobileMenuList>
            {showCommandCenter && (
              <MobileItem
                $isDarkMode={isDarkMode}
                to="/supervisor"
                onClick={handleReturnToCommandCenter}
                style={{ background: '#2563eb', color: 'white', marginBottom: '8px' }}
              >
                <FaShieldAlt /> Command Center
              </MobileItem>
            )}

            {navItems.map((item) => (
              <MobileItem $isDarkMode={isDarkMode} key={item.to} to={item.to} onClick={() => setShowMobile(false)}>
                {item.icon} {item.label}
              </MobileItem>
            ))}
          </MobileMenuList>

          <MobileLogout $isDarkMode={isDarkMode} onClick={() => { handleLogout(); setShowMobile(false); }}>
            <FaSignOutAlt /> Logout
          </MobileLogout>
        </MobileMenu>
      </>
    );
  }

  // Desktop Sidebar View
  return (
    <Sidebar collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
      <SidebarInner>
        <SidebarHeader collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
          <LogoWrap collapsed={collapsed ? 1 : 0}>
            <LogoImage src={logo} alt="SPIRITMAN" />
          </LogoWrap>

          <ProfileRow collapsed={collapsed ? 1 : 0}>
            <ProfileGroup>
              <AvatarBox $isDarkMode={isDarkMode}>
                {profileData.picture ? (
                  <img 
                    src={profileData.picture.startsWith("blob:") || profileData.picture.startsWith("http") ? profileData.picture : `${backendUrl}${profileData.picture}`} 
                    alt="Profile" 
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                ) : ( initials )}
              </AvatarBox>

              <BrandTextWrap collapsed={collapsed ? 1 : 0}>
                <Username $isDarkMode={isDarkMode}>{displayName}</Username>
                <UserRole $isDarkMode={isDarkMode}>
                  {displayRole}
                </UserRole>
                <DateText $isDarkMode={isDarkMode}>{currentDate}</DateText>
                <ActiveStatus $isDarkMode={isDarkMode}><span /> Active</ActiveStatus>
              </BrandTextWrap>
            </ProfileGroup>

            <ToggleBtn $isDarkMode={isDarkMode} onClick={() => setCollapsed(!collapsed)}>
              <FaBars size={14} />
            </ToggleBtn>
          </ProfileRow>
        </SidebarHeader>

        <NavScroll ref={scrollContainerRef} onScroll={handleScroll}>
          <Menu>
            {showCommandCenter && (
              <Item 
                to="/supervisor" 
                collapsed={collapsed ? 1 : 0} 
                $isDarkMode={isDarkMode}
                onClick={handleReturnToCommandCenter}
                style={{ background: '#2563eb', color: 'white', marginBottom: '12px' }}
              >
                <IconWrap><FaShieldAlt /></IconWrap>
                <Label collapsed={collapsed ? 1 : 0}>Command Center</Label>
                {collapsed && <Tooltip $isDarkMode={isDarkMode}>Command Center</Tooltip>}
              </Item>
            )}

            {navItems.map((item) => (
              <Item key={item.to} to={item.to} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
                <IconWrap>{item.icon}</IconWrap>
                <Label collapsed={collapsed ? 1 : 0}>{item.label}</Label>
                {collapsed && <Tooltip $isDarkMode={isDarkMode}>{item.label}</Tooltip>}
              </Item>
            ))}
          </Menu>
        </NavScroll>

        <BottomArea $isDarkMode={isDarkMode}>
          <LogoutButton onClick={handleLogout} collapsed={collapsed ? 1 : 0} $isDarkMode={isDarkMode}>
            <IconWrap><FaSignOutAlt /></IconWrap>
            <Label collapsed={collapsed ? 1 : 0}>Logout</Label>
            {collapsed && <Tooltip $isDarkMode={isDarkMode}>Logout</Tooltip>}
          </LogoutButton>
        </BottomArea>
      </SidebarInner>
    </Sidebar>
  );
};

export default Navbar;